// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__21syO","title":"AfterBackImages_title__1es9e","images":"AfterBackImages_images__147n6"};